import logoutIcon from 'assets/logout.svg'
import {useAuth} from 'features/common/context/auth'
import {useUser} from 'features/authorized/context/user'
import {useLocation} from 'react-router-dom'

const navButtons: Record<string, string> = {
    '/qr': 'QR-code',
    '/statistics': 'Statistics',
}

function Header() {
    const {logout} = useAuth()
    const {user} = useUser()
    const location = useLocation()
    const currentPageName = navButtons[location.pathname] || ''
    return (
        <div className="flex flex-1 items-center justify-between py-5 px-4 text-white">
            <div className="w-0 whitespace-nowrap text-xs">
                {currentPageName}
            </div>
            <div className="self-center bg-yellow-40 text-center font-bold">
                {user ? user.organization.name : ''}
            </div>
            <div className="relative w-0">
                <div className="absolute right-0 top-1/2 flex w-8 -translate-y-1/2">
                    <img onClick={logout} src={logoutIcon} alt="logout" />
                </div>
            </div>
        </div>
    )
}
export default Header
